// extracted by mini-css-extract-plugin
export default {"container":"zN-z","title":"AN-z","link":"BN-z"};